module.exports = __webpack_public_path__ + "assets/images/project/people/woman-chart.png?v=aacf0437";